/** Loads every Geist weight before showing text to prevent a visible fallback-font swap. */
export const waitForAppFonts = async (): Promise<void> => {
  // A failed font request must not prevent the application from opening.
  await Promise.allSettled(
    [400, 500, 600, 700].map((weight) => document.fonts.load(`${weight} 16px "Geist"`))
  );
};
